<template lang="pug">
  ProgramSettingsFormWrapper(
    :form-data="formData"
    :disable-save.sync="disableSave"
    :keys-to-reset="keysToReset"
    title="Member Entry Settings"
  )
    ContentLoader(:width="300" :height="120" v-if="!programLoaded")
      rect(x="0", y="0", rx="4", ry="4", width="50%", height="10")
      rect(x="0", y="12", rx="4", ry="4", width="40%", height="20")

      rect(x="0", y="42", rx="4", ry="4", width="50%", height="10")
      rect(x="0", y="54", rx="4", ry="4", width="40%", height="20")

      rect(x="0", y="84", rx="4", ry="4", width="50%", height="10")
      rect(x="0", y="96", rx="4", ry="4", width="40%", height="20")
    template(v-else)
      .block
        WtSwitchQuestionInput(
          label="How will members import steps?"
          v-model="manualEntry"
          @input="disableSave = false"
          true-value-text="Device Sync & Manual Entry"
          false-value-text="Device Sync"
        )
      .block
        WtSwitchQuestionInput(
          label="Allow members to comment on another member's entry"
          v-model="allowCommentsOnMemberJournals"
          @input="disableSave = false"
        )
      .block
        WtSwitchQuestionInput(
          label="Lock entries after 15 days?"
          v-model="lockJournalEntries"
          @input="disableSave = false"
        )
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import programSettingsFormMixin from "@/mixins/programSettingsFormMixin";
import ProgramSettingsFormWrapper from "@@/ProgramSettingsAdmin/ProgramSettingsFormWrapper";
import WtSwitchQuestionInput from "@@/WtSwitchQuestionInput/WtSwitchQuestionInput";
import { ContentLoader } from "vue-content-loader";

export default {
  name: "MemberEntrySettings",

  components: {
    ProgramSettingsFormWrapper,
    ContentLoader,
    WtSwitchQuestionInput
  },

  mixins: [programSettingsFormMixin],

  computed: {
    ...mapGetters("program", [
      "coreProgramMeta",
      "programSettingsCopy",
      "programLoaded"
    ]),

    formData() {
      return {
        manualEntry: this.manualEntry,
        allowCommentsOnMemberJournals: this.allowCommentsOnMemberJournals,
        lockJournalEntries: this.lockJournalEntries
      };
    },

    keysToReset() {
      return [
        "manualEntry",
        "allowCommentsOnMemberJournals",
        "lockJournalEntries"
      ];
    },

    manualEntry: {
      set(manualEntry) {
        this.updateProgramSettingsCopy({
          key: "manualEntry",
          value: manualEntry
        });
      },
      get() {
        return Number(this.programSettingsCopy.manualEntry);
      }
    },

    allowCommentsOnMemberJournals: {
      set(allowCommentsOnMemberJournals) {
        this.updateProgramSettingsCopy({
          key: "allowCommentsOnMemberJournals",
          value: allowCommentsOnMemberJournals
        });
      },
      get() {
        return Number(this.programSettingsCopy.allowCommentsOnMemberJournals);
      }
    },

    lockJournalEntries: {
      set(lockJournalEntries) {
        this.updateProgramSettingsCopy({
          key: "lockJournalEntries",
          value: lockJournalEntries
        });
      },
      get() {
        return Number(this.programSettingsCopy.lockJournalEntries);
      }
    }
  },

  methods: {
    ...mapActions("program", ["updateProgramSettingsCopy"])
  }
};
</script>

<style lang="sass"></style>
